const Form080PICSTC = {
    picsTitle: "個人資料收集聲明",
    subtitleList: [
        { text: "收集個人資料的目的" },
        { text: "可獲轉移資料者" },
        { text: "查閱個人資料" },
    ],
    symbolStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
        { step: "(g)" },
    ],
    firstStep: [
        {
            text: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        },
        {
            text: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理有關申請。",
        },
        {
            text: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        },
        {
            text: '你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向督學(學位安排及支援)1提出(地址：九龍九龍塘沙福道19號教育局九龍塘教育服務中心西座1樓W108室或電郵：<a href="mailto:ips1@edb.gov.hk">ips1@edb.gov.hk</a>)。',
        },
    ],
    secondStep: [
        { text: "處理、核實、審核資格及查證就在學證明書的申請；" },
        {
            text: "就上文(a)項所述申請的處理、核實、審核資格及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
        },
        {
            text: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；以及",
        },
        { text: "編製統計資料、研究及政府刊物。" },
    ],
    thirdStep: [
        { text: "政府其他政策局及部門，以用於上文第1段所述的用途；" },
        { text: "與本表格相關的學校，以用於上文第1段所述的用途；" },
        { text: "你曾就披露個人資料給予訂明同意；以及" },
        { text: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。" },
    ],
};

export default Form080PICSTC;
